import { AuditTimeline } from '../../../shared/features/history/components/AuditTimeline';
import { useHistory } from '../../../shared/features/history/hooks/use-history';

/** Who changed the trip and when, from the audit trail. The tab is only offered with `audit.view`; the server refuses without it. */
export function TripHistoryTab({ tripId }: { tripId: string }) {
  const state = useHistory('trip', tripId, true);
  return <AuditTimeline state={state} />;
}
